import { FC } from 'react';

import { Trash2 } from 'lucide-react';
import useSWRMutation from 'swr/mutation';

import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

import { distributionLinksService } from 'v2/api/distributionLinksService';
import { Popconfirm } from 'v2/components/popconfirm/Popconfirm';
import { DistributionLinkModel } from 'v2/types/DistributionLinkModel';
import { handleHttpError } from 'v2/utils';

interface DistributionLinkActionsColumnProps {
  distributionLink: DistributionLinkModel;
  onRevalidate: VoidFunction;
}

export const DistributionLinkActionsColumn: FC<DistributionLinkActionsColumnProps> = ({
  distributionLink,
  onRevalidate,
}) => {
  const { trigger } = useSWRMutation(
    ['deleteDistributionLink', distributionLink.id],
    distributionLinksService.deleteDistributionLink,
    {
      onSuccess: () => {
        onRevalidate();
      },
      onError: handleHttpError,
    }
  );

  return (
    <Popconfirm message="Are you sure that you want to delete this distribution link?" onConfirm={trigger}>
      <Tooltip title="Delete" placement="top">
        <IconButton color="error">
          <Trash2 width={22} height={22} />
        </IconButton>
      </Tooltip>
    </Popconfirm>
  );
};
